import React from "react";
import "./App.css";
import HeroSection from "./components/sections/HeroSection";
import { SiteHeader } from "./components/layout/SiteHeader";
import { AboutSection } from "./components/sections/AboutSection";
import { SkillsSection } from "./components/sections/SkillsSection";
import { ProjectsSection } from "./components/sections/ProjectsSection";
import { ExperienceSection } from "./components/sections/ExperienceSection";
import { EducationSection } from "./components/sections/EducationSection";
import { ContactSection } from "./components/sections/ContactSection";

function App() {
  return (
    <div className="min-h-screen bg-[#05040a] text-slate-100">
      <div className="pointer-events-none fixed inset-0 z-0 bg-[radial-gradient(circle_at_top,_rgba(56,189,248,0.08),_transparent_55%),radial-gradient(circle_at_bottom,_rgba(248,113,113,0.08),_transparent_55%)] opacity-80 mix-blend-screen" />
      <div className="pointer-events-none fixed inset-0 z-0 bg-[linear-gradient(to_bottom,_transparent_0,_rgba(15,23,42,0.75)_45%,_transparent_80%)]" />
      <div className="pointer-events-none fixed inset-0 z-0 bg-[repeating-linear-gradient(to_right,_rgba(148,163,184,0.06)_0,_rgba(148,163,184,0.06)_1px,transparent_1px,transparent_3px)]" />

      <div className="relative z-10">
        <SiteHeader />
        <main>
          <HeroSection />
          <AboutSection />
          <SkillsSection />
          <ProjectsSection />
          <ExperienceSection />
          <EducationSection />
          <ContactSection />
        </main>
        <footer className="border-t border-slate-800/80 bg-black/60">
          <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-4 text-[11px] text-slate-400 sm:px-6 lg:px-8">
            <p>
              © {new Date().getFullYear()} Ajay Sunil. All rights reserved.
            </p>
            <p className="hidden sm:block">
              Made with &nbsp;♡
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;
